import * as React from 'react'
import MUIGrid from '@mui/material/Grid'
import { GridProps } from '@mui/material'

export function Grid(props?: GridProps) {
  return <MUIGrid {...props}>{props.children}</MUIGrid>
}
